/* Care Crests theme JS — kept minimal and dependency-free for fast loads. */
(function () {
  'use strict';

  /* ---------- Mobile menu toggle ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.quantity');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '1', 10);
    var value = (parseInt(input.value, 10) || min) + step;
    if (value < min) value = min;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery: thumbnails + lightbox zoom ---------- */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    var mainWrap = gallery.querySelector('[data-gallery-main]');

    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', 'false');
        });
        thumb.setAttribute('aria-current', 'true');
        if (mainImg) {
          mainImg.src = thumb.getAttribute('data-src-large');
          mainImg.srcset = '';
          mainImg.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
        }
      });
    });

    /* Lightbox */
    var lightbox = document.querySelector('[data-lightbox]');
    if (lightbox && mainWrap) {
      var lightboxImg = lightbox.querySelector('img');
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      var lastFocus = null;

      var openLightbox = function () {
        if (mainImg) lightboxImg.src = mainImg.src;
        lastFocus = document.activeElement;
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      };
      var closeLightbox = function () {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      };

      mainWrap.addEventListener('click', openLightbox);
      mainWrap.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(); }
      });
      closeBtn.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
      });
    }
  }

  /* ---------- Variant selection: update price, availability, URL ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsJson = document.querySelector('[data-product-variants]');
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var idInput = productForm.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var saveEl = document.querySelector('[data-product-save]');
    var stockEl = document.querySelector('[data-stock-status]');
    var addBtn = productForm.querySelector('[data-add-to-cart]');
    var moneyFormat = productForm.getAttribute('data-money-format') || '${{amount}}';

    var formatMoney = function (cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    };

    var currentVariant = function () {
      var selected = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) selected[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === undefined || opt === selected[i]; });
      });
    };

    productForm.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option-index]')) return;
      var variant = currentVariant();
      if (!variant) return;
      idInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
          if (saveEl) {
            var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            saveEl.textContent = 'Save ' + pct + '%';
            saveEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }

      if (variant.available) {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label-add'); }
        if (stockEl) {
          stockEl.className = 'stock-status stock-status--in';
          stockEl.innerHTML = '<span class="stock-status__dot" aria-hidden="true"></span> In stock — ready to ship';
        }
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-soldout'); }
        if (stockEl) {
          stockEl.className = 'stock-status stock-status--out';
          stockEl.innerHTML = '<span class="stock-status__dot" aria-hidden="true"></span> Currently out of stock';
        }
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    });
  }

  /* ---------- Cart page: auto-submit quantity changes ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.querySelectorAll('.quantity input').forEach(function (input) {
      input.addEventListener('change', function () {
        cartForm.submit();
      });
    });
  }

  /* ---------- Collection sorting ---------- */
  var sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
